import PathwayStepsView from './pathway_steps_view';

const PathwaySteps = PathwayStepsView;
export default PathwaySteps;
